import analytics from 'modules/analytics'

export const MONITOR = '/monitor/matched'
export const MONITOR_UNMATCHED = '/monitor/unmatched'
export const OUT_OF_SCOPE = '/monitor/outofscope'

export const ANALYTICS_DASHBOARD = analytics.routes.ANALYTICS_DASHBOARD
